import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    plugins: String,
    placeholder: String,
    create: Boolean,
    hideSelected: Boolean,
    closeAfterSelect: Boolean,
    maxItems: Number,
  };

  connect() {
    if (this.element.tomselect) return;

    const plugins = this.hasPluginsValue
      ? this.pluginsValue
          .split(",")
          .map((plugin) => plugin.trim())
          .filter(Boolean)
      : [];

    const config = {
      plugins,
      create: this.hasCreateValue ? this.createValue : false,
      hideSelected: this.hasHideSelectedValue ? this.hideSelectedValue : true,
      closeAfterSelect: this.hasCloseAfterSelectValue
        ? this.closeAfterSelectValue
        : false,
    };

    if (this.hasPlaceholderValue) config.placeholder = this.placeholderValue;
    if (this.hasMaxItemsValue) config.maxItems = this.maxItemsValue;

    this.instance = new TomSelect(this.element, config);
  }

  disconnect() {
    if (!this.instance) return;
    this.instance.destroy();
    this.instance = null;
  }
}
